/**
 * Slug generator — pure text → URL-slug conversion.
 * Deterministic → safe to render server-side.
 */

export type Separator = "-" | "_";

export interface SlugOptions {
  separator?: Separator;
  lowercase?: boolean;
  /** Trim the slug to at most this many characters (0 / undefined = no limit). */
  maxLength?: number;
}

export function slugify(text: string, opts: SlugOptions = {}): string {
  const sep = opts.separator ?? "-";
  const lowercase = opts.lowercase ?? true;

  // Decompose accented characters then drop the combining diacritical marks.
  let s = text.normalize("NFKD").replace(/[̀-ͯ]/g, "");
  if (lowercase) s = s.toLowerCase();

  // Any run of non-alphanumeric characters collapses to one separator.
  s = s.replace(/[^a-zA-Z0-9]+/g, sep);

  // Trim leading/trailing separators.
  const sepClass = sep === "-" ? "-" : "_";
  s = s.replace(new RegExp(`^[${sepClass}]+|[${sepClass}]+$`, "g"), "");

  if (opts.maxLength && opts.maxLength > 0 && s.length > opts.maxLength) {
    s = s.slice(0, opts.maxLength).replace(new RegExp(`[${sepClass}]+$`), "");
  }

  return s;
}
